module.exports = __webpack_public_path__ + "static/img/Ikona_multibook1300.5ce6b38d.png";